// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { subscribeToNewsletter } from "../../utils/newsletter";
import { isDesktopLocalProfile } from "../../utils/desktopProfile";
import DesktopUnavailable from "../DesktopUnavailable";
import styles from "../../styles/authForm.module.scss";

function NewsletterFormComponent() {
    const { t } = useTranslation("newsletterForm");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [status, setStatus] = useState(null);

    async function handleSubmit(event) {
        event.preventDefault();
        setLoading(true);
        setMessage(null);

        try {
            const data = await subscribeToNewsletter(email);

            // The API deliberately answers "pending" whether or not the
            // address was already on the list, so the copy here must not
            // imply either - that difference would leak list membership.
            if (data.status === "pending") {
                setStatus("success");
                setMessage(t("successMessage"));
                setEmail("");
            } else {
                throw new Error("Unexpected response");
            }
        } catch {
            setStatus("error");
            setMessage(t("errorMessage"));
        } finally {
            setLoading(false);
        }
    }

    // Offline desktop build: subscribing needs the internet, so the form (on the newsletter page and under blog posts) says so.
    if (isDesktopLocalProfile) return <DesktopUnavailable feature="newsletter" inline />;

    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="newsletter-email">
                    {t("emailLabel")}
                </label>
                <input
                    id="newsletter-email"
                    type="email"
                    className={styles.input}
                    placeholder={t("emailPlaceholder")}
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                />
            </div>

            <button type="submit" className={styles.primaryButton} disabled={loading}>
                {loading ? t("sending") : t("subscribe")}
            </button>

            {message && (
                <p
                    className={status === "error" ? styles.errorText : styles.successText}
                    role={status === "error" ? "alert" : "status"}
                >
                    {message}
                </p>
            )}

            <p className={styles.helperText}>{t("helperText")}</p>
        </form>
    );
}

export default NewsletterFormComponent;
